import Modal from '@mui/material/Modal';
import { Form, Formik } from 'formik';
import React from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

import { edit_profile_settings_path } from '../../routes';
import { createMessage } from '../../utils/backend-api/messages';
import { TextAreaField } from '../FormFields';

const validationSchema = () =>
  Yup.object({
    message: Yup.string().required('A message is required'),
  });

const MessageModal = ({ user, onClose }) => {
  const onSubmit = async ({ message }) => {
    try {
      await createMessage(user.id, message);
      onClose();
      toast.success('Your message has been sent!');
    } catch (e) {
      console.error(e);
      toast.error('Message was not sent, please try again.');
    }
  };

  return (
    <Modal open={!!user} onClose={onClose} disableScrollLock={true} className="MessageModal">
      <div className="message-modal-container">
        <button className="message-modal-close-button" onClick={onClose}></button>
        {!!user && (
          <Formik
            onSubmit={onSubmit}
            initialValues={{ message: '' }}
            validationSchema={validationSchema}
          >
            {({ isSubmitting, isValid }) => (
              <Form className="form">
                <div className="message-modal-content">
                  <div className="form-group">
                    <label className="input-label" htmlFor="message">
                      Message {user?.name}
                    </label>
                  </div>

                  {user.requiresMessageEnable && (
                    <div className="message-modal-disabled-notice">
                      Enable user profile and messaging from your{' '}
                      <a href={edit_profile_settings_path(user.currentUserId)}>profile settings</a>{' '}
                      to send a message.
                    </div>
                  )}

                  <TextAreaField
                    name="message"
                    autoComplete="off"
                    placeholder="Enter a message"
                    disabled={user.requiresMessageEnable}
                  />
                </div>
                <div className="notice">
                  Note: Your email address will appear in the recipient's message. Do not send
                  commercial promotions or spam to people using The Information’s messaging system.
                  If you do, you may lose access to this function and/or have your account
                  deactivated.
                </div>
                <div className="message-modal-footer">
                  <button
                    type="submit"
                    className="button button-red button-stretch button-small"
                    disabled={isSubmitting || !isValid || user.requiresMessageEnable}
                  >
                    Send Message
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </div>
    </Modal>
  );
};

export default MessageModal;
